(function ($) {
  "use strict";

  /*
  |--------------------------------------------------------------------------
  | Translation helper
  |--------------------------------------------------------------------------
  */

  function t(key, fallback = "") {
    if (
      typeof AevonWorkspace !== "undefined" &&
      AevonWorkspace.i18n &&
      AevonWorkspace.i18n[key]
    ) {
      return AevonWorkspace.i18n[key];
    }

    return fallback || key;
  }

  /*
  |--------------------------------------------------------------------------
  | Worker status
  |--------------------------------------------------------------------------
  */

  $(document).on("click", "[data-aevon-worker-status]", function () {
    const $button = $(this);
    const workerId = $button.data("worker-id");
    const status = $button.data("status");

    if (!workerId || !status || typeof AevonWorkspace === "undefined") {
      return;
    }

    $button.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_update_worker_status",
        nonce: AevonWorkspace.nonce,
        worker_id: workerId,
        status: status,
      },

      success: function (response) {
        if (response.success) {
          window.location.reload();

          return;
        }

        alert(
          response && response.data && response.data.message
            ? response.data.message
            : t(
                "worker_status.save_status_failed",
                "Could not save worker status.",
              ),
        );
      },

      error: function () {
        alert(t("worker_status.ajax_error", "Could not complete the request."));
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });

  /*
  |--------------------------------------------------------------------------
  | Worker worksite
  |--------------------------------------------------------------------------
  */

  $(document).on("change", "[data-aevon-worker-site]", function () {
    const $select = $(this);
    const workerId = $select.data("worker-id");
    const siteId = $select.val();

    if (!workerId || typeof AevonWorkspace === "undefined") {
      return;
    }

    $select.prop("disabled", true).addClass("opacity-50");

    $.ajax({
      url: AevonWorkspace.ajaxUrl,
      method: "POST",

      data: {
        action: "aevon_workspace_update_worker_site",
        nonce: AevonWorkspace.nonce,
        worker_id: workerId,
        site_id: siteId,
      },

      success: function (response) {
        if (!response.success) {
          alert(
            response && response.data && response.data.message
              ? response.data.message
              : t(
                  "worker_status.save_worksite_failed",
                  "Could not save worker worksite.",
                ),
          );
        }
      },

      error: function () {
        alert(t("worker_status.ajax_error", "Could not complete the request."));
      },

      complete: function () {
        $select.prop("disabled", false).removeClass("opacity-50");
      },
    });
  });
})(jQuery);
